import React from 'react';
import classNames from 'classnames';

import { useIsMobile } from '../../../hooks';

import styles from './Table.module.scss';

type Props = {
  isTradeHistoryLoader?: boolean;
}

const SkeletonLoaderRow = (props: Props) => {
  const { isTradeHistoryLoader } = props;
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <div className={styles.loadingRowMobile}>
        <div className={styles.left}>
          <div className={styles.loadingLogo} />
          <div className={styles.companyInfo}>
            <div
              style={{ width: '40%' }}
              className={classNames(styles.loadingElement, styles.loadingMargin)}
            />
            <div
              style={{ width: '68%' }}
              className={classNames(styles.loadingElement, styles.loadingMargin, styles.loadingMarginTop)}
            />
          </div>
        </div>
        <div className={styles.right}>
          <div>
            <div className={styles.loadingElement} />
            <div className={classNames(styles.loadingElement, styles.loadingMarginTop)} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <tr className={styles.loadingRow}>
      <td className={styles.companyTab}>
        <div className={styles.wrapperCompany}>
          <div className={styles.loadingLogo} />
          <div className={styles.companyInfo}>
            <div className={styles.nameAndSymbol}>
              <div className={styles.loadingElement} />
              <div className={classNames(styles.loadingElement, styles.loadingMargin)} style={{ width: 40 }} />
            </div>
          </div>
        </div>
      </td>
      <td className={styles.tableComponent}>
        <div className={styles.loadingElement} style={{ width: 40 }} />
      </td>
      <td className={styles.tableComponent}>
        <div className={styles.loadingElement} style={{ width: 66 }} />
      </td>
      <td className={styles.tableComponent}>
        <div className={styles.loadingElement} />
      </td>
      <td className={styles.tableComponent}>
        <div className={styles.loadingElement} />
      </td>
      { isTradeHistoryLoader && (
        <>
          <td className={styles.tableComponent}>
            <div className={styles.loadingElement} />
          </td>
          <td className={styles.tableComponent}>
            <div className={styles.loadingElement} />
          </td>
        </>
      )}
    </tr>
  );
};

export default SkeletonLoaderRow;
